import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, onMounted, getCurrentInstance, nextTick } from "vue";
import { LogService } from "@/services";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileItem',
  props: {
    label: { default: "Default title" },
    txt: { default: "" },
    link: { default: "" },
    isEmail: { type: Boolean, default: false },
    html: { default: "" },
    bodyClass: { default: "" },
    htmlFullWidth: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { label: string, txt: string, link: string, isEmail: boolean, html: string, bodyClass: string, htmlFullWidth: boolean };


const { label, txt, link, isEmail, html, bodyClass, htmlFullWidth } =
  toRefs(props);
const isFullWidth = computed(() => !!html.value && htmlFullWidth);
const instance = getCurrentInstance();
const slots = instance?.proxy.$slots;

onMounted(() => {
  // Wait for the DOM to update before checking
  nextTick(() => {
    // Only log error if the component is actually displaying "No information available"
    // and has a body slot that should be rendering content instead
    const el = instance?.proxy?.$el;

    // Check if el is a valid DOM element that supports querySelector
    const isElement = el && typeof el === "object" && "querySelector" in el;

    let hasVisibleContent = false;
    if (isElement) {
      const textElement = el.querySelector(".text-body-1");
      hasVisibleContent =
        textElement?.textContent?.trim() !== "No information available.";
    }

    if (
      html.value === "No information available." &&
      slots?.body &&
      !hasVisibleContent
    ) {
      LogService.error(
        `Component with label: ${label.value} might be incorrectly visible. Check v-if's and/or for missing data`
      );
    }
  });
});

return { __sfc: true,props, label, txt, link, isEmail, html, bodyClass, htmlFullWidth, isFullWidth, instance, slots }
}

})